import React, { useEffect } from "react";
import {
  Input,
  Button,
  FormFeedback,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { NAME_MAXLENGTH } from "@constants/constants";
import Spinners from "@components/custom-table/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addMembership,
  editMembership,
  getMembership,
  getMembershipCount,
} from "../services/membership-services";
import { resetError, resetState } from "../controller/membership-slice";
import { PHONE_NUMBER_MAXLENGTH } from "@constants/constants";
import { membershipSchema } from "../../../helpers/validation-schema";
import { MEMBERSHIP_PRICE } from "../../../constants/constants";
import { NUMBER_REGEX } from "../../../constants/constants";
import { handleInput } from "../../../helpers/helpers";
import CustomLabel from "../../../components/CustomLabel";
import ContentFormRepeater from "../../../components/description-form-repeater/description-form";


export const AddMembership = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const route = pathname.split("/")[2];
  const membershipId = pathname.split("/")[3];
  const success = useSelector((state) => state.membership.success);
  const membership = useSelector((state) => state.membership.memberships);
  const loading = useSelector((state) => state.membership.loading);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageQuery = parseInt(searchParams.get("current_page"));
  const successMessage = useSelector(
    (state) => state.membership.successMessage
  );
  const errorMessage = useSelector((state) => state.membership.errorMessage);

  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(membershipSchema),
  });

  useEffect(() => {
    async function fetchCount() {
      if (route === "add") {
        const count = await getMembershipCount();
        setValue("sorting", count + 1);
      }
    }
    fetchCount();
  }, [route, setValue]);

  useEffect(() => {
    if (route !== "add") {
      dispatch(getMembership(membershipId));
    }
  }, [membershipId, dispatch, route]);

  useEffect(() => {
    if (success) {
      navigate(`/membership`);
      dispatch(resetState());
    }
  }, [success, dispatch, navigate, successMessage, pageQuery]);

  useEffect(() => {
    if (errorMessage !== null) {
      toast.error(errorMessage?.message);

      errorMessage.data.items.forEach((item) => {
        const fieldName = Object.keys(item)[0];
        const message = item[fieldName];
        setError(fieldName, { type: "manual", message });
      });
    }
  }, [errorMessage, setError]);

  useEffect(() => {
    if (membership) {
      setValue("name", membership?.name);
      setValue("duration", membership?.duration);
      setValue("price", membership?.price);
      setValue("sorting", membership?.sorting);
    }
  }, [membership, setValue]);

  const onSubmit = (data) => {

    const hasValidDescription = data.formRows2.some((row) => row.content !== "");
    if (!hasValidDescription) {
      data.formRows2 = []; // Set formRows to an empty array
    }




    if (route !== "edit") {
      const formattedData = {
        ...data,
        sorting: parseInt(data.sorting),
        duration: parseInt(data.duration),
        price: parseInt(data.price),
        payment_description:data.formRows2 || []
      };
      dispatch(addMembership(formattedData));
    } else {
      const formattedData = {
        ...data,
        sorting: parseInt(data.sorting),
        duration: parseInt(data.duration),
        price: parseInt(data.price),
        payment_description:data.formRows2 || []
      };

      dispatch(editMembership({ id: membershipId, data: formattedData }));
    }
  };

  const handleInputChange = (event, field) => {
    const { value } = event.target;
    const formattedValue = value.replace(/\D/g, "");
    setValue(field, formattedValue);
  };
  return (
    <div className="page-content">
      {loading ? (
        <Spinners />
      ) : (
        <>
          <>
            <ToastContainer autoClose={2000} />
            <Card>
              <CardBody className="text-start">
                <CardTitle className="mb-4 my-3">
                  {route === "edit"
                    ? "Edit Membership"
                    : route === "view"
                    ? "View Membership"
                    : "Create Membership"}
                </CardTitle>
                <FormProvider {...{ control, handleSubmit, setValue, errors }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Sorting" isRequired>
                          Sorting
                        </CustomLabel>
                        <Controller
                          name="sorting"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Sorting"
                                invalid={!!errors.sorting}
                                maxLength={PHONE_NUMBER_MAXLENGTH}
                                onChange={(e) =>
                                  handleInputChange(e, "sorting")
                                }
                              />
                              {errors.sorting && (
                                <FormFeedback>
                                  {errors.sorting.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Name" isRequired>
                          Membership Plan Name
                        </CustomLabel>
                        <Controller
                          name="name"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Enter Plan Name"
                                invalid={!!errors.name}
                                maxLength={NAME_MAXLENGTH}
                              />
                              {errors.name && (
                                <FormFeedback>
                                  {errors.name.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="duration" isRequired>
                          Duration
                        </CustomLabel>
                        <Controller
                          name="duration"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                onInput={(e) => handleInput(e, NUMBER_REGEX)}
                                placeholder="Duration value"
                                invalid={!!errors.duration}
                                maxLength={PHONE_NUMBER_MAXLENGTH}
                              />
                              {errors.duration && (
                                <FormFeedback>
                                  {errors.duration.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="price" isRequired>
                          Price
                        </CustomLabel>
                        <Controller
                          name="price"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                onInput={(e) => handleInput(e, NUMBER_REGEX)}
                                placeholder="Enter Price Value"
                                invalid={!!errors.price}
                                maxLength={MEMBERSHIP_PRICE}
                              />
                              {errors.price && (
                                <FormFeedback>
                                  {errors.price.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                      <Col md={6} mb={5}>
                      <ContentFormRepeater data={membership?.payment_description || []} route={route} />
                      </Col>
                    </Row>
                  <Row>
                    <Col md={6}></Col>
                    <Col md={6}>
                      <div className="d-flex justify-content-end gap-2">
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => {
                            navigate(`/membership`);
                            dispatch(resetError());
                          }}
                        >
                          {route === "view" ? "Back" : "Cancel"}
                        </Button>
                        {route !== "view" ? (
                          <Button type="submit" color="primary">
                            {route === "edit"
                              ? "Edit Membership"
                              : "Create Membership"}
                          </Button>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </form>
                </FormProvider>
              </CardBody>
            </Card>
          </>
        </>
      )}
    </div>
  );
};

export default AddMembership;
